const IMAGE_FILE = /\.(jpe?g|png|gif|webp|avif|bmp|heic)$/i
const VIDEO_FILE = /\.(mp4|webm|mov|m4v|ogg|ogv)$/i
const AUDIO_FILE = /\.(mp3|wav|m4a|aac|ogg|flac)$/i

export const postType = (item) => String(item?.type ?? item?.typed ?? '').trim().toLowerCase()

const mediaFile = (item) => String(item?.image || '').split('|')[0]

export const isMusicPost = (item) => {
  const type = postType(item)
  const file = mediaFile(item)
  return type === 'a' || AUDIO_FILE.test(file)
}

export const isWatchVideo = (item) => {
  if (isMusicPost(item)) return false
  const type = postType(item)
  const file = mediaFile(item)
  if (VIDEO_FILE.test(file)) return true
  return type === 's' || type === 'l' || type === 'm'
}

export const isPhotoPost = (item) => {
  if (isWatchVideo(item) || isMusicPost(item)) return false
  const type = postType(item)
  const file = mediaFile(item)
  return type === 'i' || IMAGE_FILE.test(file)
}

export const isShortPost = (item) => {
  const type = postType(item)
  return type === 's' || type === 'short' || type === 'shorts'
}

export const watchClipPath = (id) => `/watch?v=${encodeURIComponent(id)}`

export const mediaPath = (item) => {
  if (!item?.id) return '/'
  if (isMusicPost(item)) return `/sound/${encodeURIComponent(item.id)}`
  if (isPhotoPost(item)) return `/post/${encodeURIComponent(item.id)}`
  if (isShortPost(item)) return watchClipPath(item.id)
  return `/video/${encodeURIComponent(item.id)}`
}

export const shareUrlFor = (item, path) => `${window.location.origin}${path || mediaPath(item)}`

export const shareMedia = async (item, fallbackTitle = 'Pinweelo', path) => {
  const url = shareUrlFor(item, path)
  const title = (item && item.title) || fallbackTitle
  try {
    if (navigator.share) {
      await navigator.share({ title, text: url, url })
      return 'shared'
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(url)
      return 'copied'
    }
    window.prompt('Copy this link', url)
    return 'copied'
  } catch (err) {
    if (err && err.name === 'AbortError') return 'abort'
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(url)
        return 'copied'
      }
    } catch (_) {}
    window.prompt('Copy this link', url)
    return 'copied'
  }
}

export const herePath = (location) => `${location.pathname}${location.search || ''}`

const isWatchClip = (path) => String(path || '').startsWith('/watch?')

export const leavePath = (location) => {
  const here = location ? herePath(location) : '/'
  const prev = location && location.state && location.state.from
  if (prev && prev !== here && !isWatchClip(prev)) return prev
  if (String(here).startsWith('/sound/')) return '/watch'
  if (isWatchClip(here)) return '/'
  return here || '/'
}

export const openWatchState = (item, location, extra = {}) => ({
  item,
  from: leavePath(location),
  ...extra
})

const postSnap = (item) => {
  if (!item || !item.id) return null
  return {
    id: item.id,
    image: item.image,
    title: item.title,
    type: item.type || 'i',
    userid: item.userid,
    tages: item.tages,
    description: item.description,
    date: item.date,
    thumbnail: item.thumbnail,
    views: item.views,
    vcomments: item.vcomments,
    vlikes: item.vlikes,
    vdislikes: item.vdislikes,
    userImg: item.userImg,
    email: item.email,
    link: item.link,
    followers: item.followers,
    communityid: item.communityid
  }
}

export const openPostState = (item, location, extra = {}) => {
  const feed = (extra.feed || []).map(postSnap).filter(Boolean)
  return {
    item: postSnap(item) || item,
    from: leavePath(location),
    feed,
    source: extra.source || (feed.length > 1 ? 'list' : 'watch')
  }
}
